import { Component, OnInit } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { GTMSegmentService } from 'src/app/services/gtm-segment.service';

@Component({
    selector: 'app-syndicate-ticket-preview',
    templateUrl: './syndicate-ticket-preview.component.html',
    styleUrls: ['./syndicate-ticket-preview.component.scss'],
    standalone: true,
    imports: [IonicModule],
})
export class SyndicateTicketPreviewComponent implements OnInit {
  ticketImageUrl;

  constructor(
    private modalCtrl: ModalController,
    private GTMSegment: GTMSegmentService
  ) {
    this.GTMSegment.GTMPopupInitialization("SyndicateTicketPreview");
  }

  ngOnInit() { }

  back() {
    this.modalCtrl.dismiss().catch(err => { return err });
  }

}
